import {NgModule} from '@angular/core';
import {CommonModule} from '@angular/common';
import {TachesPanelComponent} from './taches-panel/taches-panel.component';
import {TacheComponent} from '../../common/tache/tache/tache.component';
import {EparcoursComponentsModule} from '../../common/eparcours-components/eparcours-components.module';
import {EparcoursValidatorsModule} from '../../validators/validators-with-message/eparcours-validators/eparcours-validators.module';
import {FormsModule, ReactiveFormsModule} from '@angular/forms';
import {DatePickerModule} from '@syncfusion/ej2-angular-calendars';
import {DropDownButtonModule} from '@syncfusion/ej2-angular-splitbuttons';
import {DragDropModule} from '@angular/cdk/drag-drop';
import {SecurityCommonModule} from '../../common/security-common/security-common.module';
import { EditTacheFormComponent } from "../../common/tache/edit-tache-form/edit-tache-form.component";
import { ChoixTypeLienComponent } from "../../common/tache/edit-tache-form/choix-type-lien/choix-type-lien.component";
import { ChoixLienComponent } from "../../common/tache/edit-tache-form/choix-lien/choix-lien.component";
import { MultiselectorModule } from "../../common/multiselect/multiselector.module";
import { EditLiensTachesComponent } from '../../common/tache/edit-tache-form/edit-liens-taches/edit-liens-taches.component';
import { LienPersonneDetailsTooltipComponent } from '../../common/tache/tache/lien-personne-details-tooltip/lien-personne-details-tooltip.component';
import { LienFormateurDetailsTooltipComponent } from '../../common/tache/tache/lien-formateur-details-tooltip/lien-formateur-details-tooltip.component';
import { LienEntrepriseDetailsTooltipComponent } from '../../common/tache/tache/lien-entreprise-details-tooltip/lien-entreprise-details-tooltip.component';
import { LienSessionDetailsTooltipComponent } from '../../common/tache/tache/lien-session-details-tooltip/lien-session-details-tooltip.component';
import { ListeTachesComponent } from '../../common/tache/liste-taches/liste-taches.component';
import { LienPersonnelDetailsTooltipComponent } from 'src/app/common/tache/tache/lien-personnel-details-tooltip/lien-personnel-details-tooltip.component';

@NgModule({
  declarations: [
    TachesPanelComponent,
    ListeTachesComponent,
    TacheComponent,
    EditTacheFormComponent,
    ChoixTypeLienComponent,
    ChoixLienComponent,
    EditLiensTachesComponent,
    LienPersonneDetailsTooltipComponent,
    LienFormateurDetailsTooltipComponent,
    LienEntrepriseDetailsTooltipComponent,
    LienSessionDetailsTooltipComponent,
    LienPersonnelDetailsTooltipComponent
  ],
  exports: [ListeTachesComponent,TachesPanelComponent, TacheComponent,],
  imports: [
    CommonModule,
    EparcoursComponentsModule,
    EparcoursValidatorsModule,
    ReactiveFormsModule,
    DatePickerModule,
    DropDownButtonModule,
    DragDropModule,
    FormsModule,
    SecurityCommonModule,
    MultiselectorModule]
})
export class GestionTachesModule {}
